import { FuelType } from 'graphql/generated';

export const FuelTypeValues: { [key in FuelType]: string } = {
  diesel: 'Diesel',
  electric: 'Electric',
  flex: 'Flex Fuel',
  gas: 'Gasoline',
  hybrid: 'Hybrid',
  hydrogen: 'Hydrogen',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromFuelTypeValue = (value: string) => {
  switch (value) {
    case 'Diesel':
      return FuelType.diesel;
    case 'Electric':
      return FuelType.electric;
    case 'Flex Fuel':
      return FuelType.flex;
    case 'Gasoline':
      return FuelType.gas;
    case 'Hybrid':
      return FuelType.hybrid;
    case 'Hydrogen':
      return FuelType.hydrogen;
    case 'Other':
      return FuelType.other;
    case 'Unknown':
      return FuelType.unknown;
    default:
      throw new Error(`invalid FuelType value: ${value}`);
  }
};
